export default __webpack_public_path__ + "static/media/Suivi-2.6d8acced.gif";